<div class="content-containerv2">
  <div id="main-content" class="content-containerv2__form-group">
    <div class="form-containerv2">
      <form
        class=""
        [formGroup]="signInForm"
        (ngSubmit)="login()"
        [eevFormTrackingConfig]="formTrackingConfig"
        [eevTrackDistinctFieldErrors]="fieldErrors$"
        eevTrackFormStart
        role="form"
        aria-labelledby="login-heading"
        novalidate
      >
        <h2 id="login-heading" class="titlev2 be-section-mb--responsive">
          Manage my Best Egg account
        </h2>
        <app-be-input-group-reactive
          [beFormGroup]="signInForm"
          [beFormControl]="signInForm.controls['username']"
          beFormControlName="username"
          inputLabel="Username"
          inputPlaceholder="Username"
          hint="Not phone/email"
          requiredError="Username is required"
          maskValue="y*"
          [specialCharactersValues]="['space']"
          [patternsValue]="whitespaceFilter"
          [detailError]="usernameError"
          variant="sm"
          [eevTrackingConfig]="
            formTrackingConfig.fields[AuthFormFieldName.USERNAME]
          "
          [errorTrackingSubject]="fieldErrors$"
        >
        </app-be-input-group-reactive>
        <app-be-input-group-reactive
          [beFormGroup]="signInForm"
          [beFormControl]="signInForm.controls['password']"
          beFormControlName="password"
          inputLabel="Password"
          inputType="password"
          inputPlaceholder="Password"
          requiredError="Password is required"
          [detailError]="passwordError"
          variant="sm"
          [eevTrackingConfig]="
            formTrackingConfig.fields[AuthFormFieldName.PASSWORD]
          "
          [errorTrackingSubject]="fieldErrors$"
        >
        </app-be-input-group-reactive>
        <div
          class="btn-group btn-group--horizontal be-section-mt--responsive be-section-mb--responsive"
        >
          <app-api-btn [isSubmitting]="isLoading" btnId="loginBtn"
            >Login <span class="sr-only">to your account</span></app-api-btn
          >
          <p class="text-responsive text-navy-800 button-groupv2__item">
            <a
              [eevTrackClick]="AuthLinkType.FORGOT_USER_PASS"
              routerLink="/loginHelp/panel"
              class="link-responsive text-navy-tint-900 link-btn-ghost"
              >Forgot username or password?</a
            >
          </p>
        </div>
      </form>

      <p class="text-responsive text-navy-800 mb-4">
        Don't have an account yet?
        <a
          [eevTrackClick]="AuthLinkType.REGISTER"
          routerLink="/register/enroll"
          class="link-responsive text-navy-tint-900"
          aria-label="Don't have an account yet? Click here to register."
          >Register</a
        >
      </p>
      <p id="continue-application-link" class="text-responsive text-navy-800">
        Already started a loan application?
        <a
          [eevTrackClick]="AuthLinkType.CONTINUE_APP"
          href="{{ resumeApplicationUrl }}"
          class="link-responsive text-navy-tint-900 resume-application-text"
          aria-label="Click here to continue your loan application"
        >
          Click here to continue
        </a>
      </p>
      <div class="smallprint-groupv2 be-section-mt--responsive">
        <svg
          class="smallprint-groupv2__icon"
          viewBox="0 0 100 100"
          aria-hidden="true"
        >
          <use href="assets/icons-v2/sprites.svg#lock"></use>
        </svg>
        <p class="text-responsive text-navy-800">
          Your data is secured by industry-leading encryption
        </p>
      </div>
    </div>
  </div>
  <aside class="content-containerv2__img-group" aria-hidden="true">
    <img
      src="../../../assets/images/login-imagev2.png"
      alt="Man lifting up his child"
    />
  </aside>
</div>
